import {
  TOGGLE_NAV_DRAWER,
  TOGGLE_SHOW_HEADER_FOOTER,
  CHANGE_ACTIVE_NAV_BOX_ITEM,
  LOADING_SHAHRZAD,
} from "../actionTypes/layout";

export const toggleNavDrawer = () => ({ type: TOGGLE_NAV_DRAWER });
export const toggleShowHeaderFooter = () => ({
  type: TOGGLE_SHOW_HEADER_FOOTER,
});

export const changeActiveNavBoxItem = (id) => ({
  type: CHANGE_ACTIVE_NAV_BOX_ITEM,
  data: id,
});
export const toggleLoadingShahrzad = (show) => ({
  type: LOADING_SHAHRZAD,
  showShahrzad: show,
});
